document.addEventListener("DOMContentLoaded", function() {
    var current_slide = 1;
    var slider_active = false;

    const gallery_switch = document.getElementById('gallery-switch')
    const gallery_switch_close = document.getElementById('gallery-close')
    const gallery_list_wrapper = document.getElementById('gallery-list__wrapper');
    const gallery_release_gallery = document.getElementById('release-gallery');
    const gallery_list = document.getElementById('gallery-list');
    const gallery_next = document.getElementById('gallery-next');
    const gallery_prev = document.getElementById('gallery-prev');

    if(gallery_switch && gallery_list_wrapper && gallery_list && gallery_switch_close && gallery_next && gallery_prev){
        gallery_switch.onclick = function(event) {
            event.preventDefault();
            event.stopPropagation();
            this.classList.toggle('active');
            gallery_list_wrapper.scrollTo(0, 0);
            gallery_list_wrapper.classList.toggle('active');
            gallery_list.classList.toggle('active');
            gallery_release_gallery.classList.toggle('active');
        }

        gallery_switch_close.onclick = function(event) {
            event.preventDefault();
            event.stopPropagation();
            this.classList.toggle('active');
            gallery_list_wrapper.classList.toggle('active');
            gallery_list.classList.toggle('active');
            gallery_release_gallery.classList.toggle('active');
        }

        gallery_prev.onclick = function(event) {
            if(!slider_active){
                event.preventDefault();
                event.stopPropagation();
                gallery_list.classList.add('click-prev');
                slider_active = true;
                setTimeout(() => {
                    let active_element = document.querySelector('.gallery-item.active');
                    let prev_element = active_element?.previousElementSibling;
                    let next_element = active_element?.nextElementSibling;
                    active_element.classList.remove('active');
                    if(prev_element){
                        prev_element.classList.remove('prev');
                        prev_element.classList.add('active');
                        updateClasses();
                    }
                    if(next_element){
                        next_element.classList.remove('next');
                    }
                    gallery_list.classList.remove('click-prev');
                    slider_active = false
                }, 500);
            }
        }

        gallery_next.onclick = function(event) {
            if(!slider_active){
                event.preventDefault();
                event.stopPropagation();
                slider_active = true;
                gallery_list.classList.add('click-next');
                setTimeout(() => {
                    let active_element = document.querySelector('.gallery-item.active');
                    let prev_element = active_element?.previousElementSibling;
                    let next_element = active_element?.nextElementSibling;
                    active_element.classList.remove('active');
                    if(prev_element){
                        prev_element.classList.remove('prev');
                    }
                    if(next_element){
                        next_element.classList.remove('next');
                        next_element.classList.add('active');
                        updateClasses();
                    }
                    gallery_list.classList.remove('click-next');
                    slider_active = false
                }, 500);
            }
        }

        //get next & active
        const updateClasses = () => {
            let active_element = document.querySelector('.gallery-item.active');
            let prev_element = active_element?.previousElementSibling;
            let next_element = active_element?.nextElementSibling;
            if(prev_element){
                prev_element.classList.toggle('prev');
                gallery_list_wrapper.classList.remove('no-prev');
            } else {
                gallery_list_wrapper.classList.add('no-prev');
            }
            if(next_element){
                next_element.classList.toggle('next');
                gallery_list_wrapper.classList.remove('no-next');
            } else {
                gallery_list_wrapper.classList.add('no-next');
            }
        }

        updateClasses();
    }
});

document.addEventListener("turbo:render", function() {
    var current_slide = 1;
    var slider_active = false;

    const gallery_switch = document.getElementById('gallery-switch')
    const gallery_switch_close = document.getElementById('gallery-close')
    const gallery_list_wrapper = document.getElementById('gallery-list__wrapper');
    const gallery_release_gallery = document.getElementById('release-gallery');
    const gallery_list = document.getElementById('gallery-list');
    const gallery_next = document.getElementById('gallery-next');
    const gallery_prev = document.getElementById('gallery-prev');

    if(gallery_switch && gallery_list_wrapper && gallery_list && gallery_switch_close && gallery_next && gallery_prev){
        gallery_switch.onclick = function(event) {
            event.preventDefault();
            event.stopPropagation();
            this.classList.toggle('active');
            gallery_list_wrapper.classList.toggle('active');
            gallery_list.classList.toggle('active');
            gallery_release_gallery.classList.toggle('active');
        }

        gallery_switch_close.onclick = function(event) {
            event.preventDefault();
            event.stopPropagation();
            this.classList.toggle('active');
            gallery_list_wrapper.classList.toggle('active');
            gallery_list.classList.toggle('active');
            gallery_release_gallery.classList.toggle('active');
        }

        gallery_prev.onclick = function(event) {
            if(!slider_active){
                event.preventDefault();
                event.stopPropagation();
                gallery_list.classList.add('click-prev');
                slider_active = true;
                setTimeout(() => {
                    let active_element = document.querySelector('.gallery-item.active');
                    let prev_element = active_element?.previousElementSibling;
                    let next_element = active_element?.nextElementSibling;
                    active_element.classList.remove('active');
                    if(prev_element){
                        prev_element.classList.remove('prev');
                        prev_element.classList.add('active');
                        updateClasses();
                    }
                    if(next_element){
                        next_element.classList.remove('next');
                    }
                    gallery_list.classList.remove('click-prev');
                    slider_active = false
                }, 500);
            }
        }

        gallery_next.onclick = function(event) {
            if(!slider_active){
                event.preventDefault();
                event.stopPropagation();
                slider_active = true;
                gallery_list.classList.add('click-next');
                setTimeout(() => {
                    let active_element = document.querySelector('.gallery-item.active');
                    let prev_element = active_element?.previousElementSibling;
                    let next_element = active_element?.nextElementSibling;
                    active_element.classList.remove('active');
                    if(prev_element){
                        prev_element.classList.remove('prev');
                    }
                    if(next_element){
                        next_element.classList.remove('next');
                        next_element.classList.add('active');
                        updateClasses();
                    }
                    gallery_list.classList.remove('click-next');
                    slider_active = false
                }, 500);
            }
        }

        //get next & active
        const updateClasses = () => {
            let active_element = document.querySelector('.gallery-item.active');
            let prev_element = active_element?.previousElementSibling;
            let next_element = active_element?.nextElementSibling;
            if(prev_element){
                prev_element.classList.toggle('prev');
                gallery_list_wrapper.classList.remove('no-prev');
            } else {
                gallery_list_wrapper.classList.add('no-prev');
            }
            if(next_element){
                next_element.classList.toggle('next');
                gallery_list_wrapper.classList.remove('no-next');
            } else {
                gallery_list_wrapper.classList.add('no-next');
            }
        }

        updateClasses();
    }
});

document.addEventListener('turbo:render', () => {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        document.querySelectorAll('.img-responsive').forEach((img) => {
        img.outerHTML = img.outerHTML; // eslint-disable-line no-param-reassign, no-self-assign
        });
    }
});